/**
 * SHA-256 über WebCrypto (Browser und Node ≥ 19 stellen `globalThis.crypto.subtle` bereit).
 * Prüfsumme jedes Exports landet in `exports[].sha256` (Spec 7).
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
export const bytesToHex = (bytes: Uint8Array): string => Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');

const toBytes = async (input: Blob | ArrayBuffer | Uint8Array | string): Promise<Uint8Array> => {
    if (typeof input === 'string') {
        return new TextEncoder().encode(input);
    }
    if (input instanceof Uint8Array) {
        return input;
    }
    if (input instanceof ArrayBuffer) {
        return new Uint8Array(input);
    }
    return new Uint8Array(await input.arrayBuffer());
};

export const sha256Hex = async (input: Blob | ArrayBuffer | Uint8Array | string): Promise<string> => {
    const bytes = await toBytes(input);
    const digest = await globalThis.crypto.subtle.digest('SHA-256', bytes);
    return bytesToHex(new Uint8Array(digest));
};
